import { Http } from '../../../../support';

const initialState = {
  data: {},
  busy: false,
  error: undefined,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.reportes.clientes.info = {
      ...state.admin.reportes.clientes.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.admin.reportes.clientes.info.busy = true;
  });

  try {
    const response = await Http.get(`api/clientes/${id}`, { params });

    store.setState((state) => {
      state.admin.reportes.clientes.info = {
        ...state.admin.reportes.clientes.info,
        data: response.data,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.reportes.clientes.info.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.reportes.clientes.info.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.reportes.clientes.info = { ...initialState };
  });
};

const ReporteClienteInfoStore = {
  state: () => initialState,
  actions: {
    info,
    reset,
    setPartialState,
  },
};

export default ReporteClienteInfoStore;
